import { Users, User } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface PublicCandidatesSectionProps {
  candidateCount?: number
  partyLeaderName?: string
  className?: string
}

export function PublicCandidatesSection({
  candidateCount = 0,
  partyLeaderName,
  className,
}: PublicCandidatesSectionProps) {
  return (
    <Card className={cn(className)}>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Users className="h-4 w-4" />
          Candidates
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Candidate count */}
          <div className="space-y-1">
            <p className="text-2xl font-semibold">
              {candidateCount}
              <span className="text-sm font-normal text-muted-foreground ml-1">
                {candidateCount === 1 ? 'candidate' : 'candidates'}
              </span>
            </p>
          </div>

          {/* Party leader */}
          <div className="space-y-1">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <User className="h-3.5 w-3.5" />
              <span className="text-xs">Party Leader</span>
            </div>
            <p className="text-sm">
              {partyLeaderName || (
                <span className="text-muted-foreground">(none)</span>
              )}
            </p>
          </div>

          {/* Placeholder if no candidates */}
          {candidateCount === 0 && (
            <div className="text-center pt-2 border-t">
              <p className="text-xs text-muted-foreground">
                This party has not yet recruited any candidates
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
